import { render } from "./CurriculumEvents.vue?vue&type=template&id=b48ca3ec&scoped=true"
import script from "./CurriculumEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./CurriculumEvents.vue?vue&type=script&setup=true&lang=js"

import "./CurriculumEvents.vue?vue&type=style&index=0&id=b48ca3ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b48ca3ec"],['__file',"src/components/Study/CurriculumEvents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b48ca3ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b48ca3ec', __exports__)) {
    api.reload('b48ca3ec', __exports__)
  }
  
  module.hot.accept("./CurriculumEvents.vue?vue&type=template&id=b48ca3ec&scoped=true", () => {
    api.rerender('b48ca3ec', render)
  })

}


export default __exports__